"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhonenumberStockConnectelCountries = void 0;
exports.PhonenumberStockConnectelCountries = ['SE', 'NO', 'FI',];
